module.exports = __webpack_public_path__ + "static/img/8.f99d705.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/14/8.png
// module id = SVsN
// module chunks = 2